export const SITE = {
  name: "Blooming Chaitanya Academy",
  shortName: "Blooming Chaitanya",
  tagline: "Nurturing Minds, Shaping Futures",
  sanskrit: "विद्यया विन्दते अमृतम्",
  phone1Display: "+91 88759 93350",
  phone1: "+918875993350",
  phone2Display: "+91 93528 49710",
  phone2: "+919352849710",
  whatsapp: "918875993350",
  whatsappLink:
    "https://wa.me/918875993350?text=Namaste!%20I%27d%20like%20to%20enquire%20about%20admission%20at%20Blooming%20Chaitanya%20Academy.",
  email: "enroll@bloomingchaitanya.in",
  address: "G-166, Bhawani Nagar, Murlipura, Jaipur, Rajasthan 302039",
  hours: "Mon – Sat · 9:00 AM – 5:00 PM",
  mapEmbed:
    "https://www.google.com/maps?q=G-166,+Bhawani+Nagar,+Murlipura,+Jaipur,+Rajasthan+302039&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=G-166,+Bhawani+Nagar,+Murlipura,+Jaipur,+Rajasthan+302039",
  socials: {
    youtube: "https://www.youtube.com/@bloomingchaitanya",
    instagram: "https://www.instagram.com/bloomingchaitanya",
    facebook: "https://www.facebook.com/bloomingchaitanya",
    whatsapp: "https://wa.me/918875993350",
  },
};

export const IMAGES = {
  logo: "/images/logo.png",
  hero: "/images/classroom.png",
  principal: "/images/principal.jpg",
  circle: "/images/assembly.jpeg",
  toddler: "/images/classroom.png",
  preschool: "/images/christmas-collage.jpeg",
  christmas: "/images/christmas.jpeg",
  art: "/images/art.png",
  diyas: "/images/diyas.png",
  outing: "/images/outing.png",
};

export const PROGRAM_OPTIONS = [
  "Toddler Class (18 months – 3 yrs)",
  "Nursery (3 – 4 yrs)",
  "Pre-Kindergarten (4+ yrs)",
  "Pre-Primary (4+ yrs)",
  "Classes 1st – 8th (6+ yrs)",
];

export const PHOTO_OPTIONS = [
  { label: "No photo", value: "" },
  { label: "Classroom (little girl with book)", value: "/images/classroom.png" },
  { label: "Morning Assembly", value: "/images/assembly.jpeg" },
  { label: "Christmas Celebration (collage)", value: "/images/christmas-collage.jpeg" },
  { label: "Christmas Activity", value: "/images/christmas.jpeg" },
  { label: "Art Class", value: "/images/art.png" },
  { label: "Diwali Diya Craft", value: "/images/diyas.png" },
  { label: "School Outing (Fun Kingdom)", value: "/images/outing.png" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
